//Home Page
import React from "react";
import Header from "../../Base/Header/";
import styles from "../../Styles/Home/styles.module.css";
import books from "../../images/books.svg";
import PlaylistSlider from "../../Components/PlaylistSlider/playlistSlider";
import Footer from "../../Base/Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import { API } from "../../backend";
import vr from "../../images/vr.jpeg";
import industrial from "../../images/industrial.jpeg";

const Home = () => {
  const [topPlaylist, setTopPlaylist] = React.useState([]);

  React.useEffect(() => {
    var config = {
      method: "get",
      url: `${API}/playlist/getTop`,
    };

    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        console.log(response, "response top");
        if (response.data.status === "success") {
          setTopPlaylist(response.data.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <div className={styles.container}>
      <Header />
      {/* heading container */}

      <div className={styles.parent}>
        <div className={styles.left}>
          <p className={styles.tagline}>Upgrading the community</p>
          <p className={styles.subheading}>
            We strive to help and bring together the online learners community
            by compiling knowledgeable resources from all over the internet.
          </p>
          <div
            className={`${styles.btnContainer} ${
              isAuthenticated() ? styles.alignbtn : ""
            }`}
          >
            <a href="/playlists">
              <button className={styles.button}>Discover</button>
            </a>

            {!isAuthenticated() && (
              <Link to="/signup">
                <button className={styles.signup}>Create Account</button>
              </Link>
            )}
          </div>
        </div>

        {/* image container */}
        <div className={styles.imgContainer}>
          <img src={books} alt="" className={styles.book} />
        </div>
      </div>
      {/* <img src={scroll} alt="" className={styles.scroll} /> */}

      <PlaylistSlider heading="Top Playlists" playlist={topPlaylist} />
      <div className={styles.futuregoals}>
        <h2 className={styles.heading}>Our Future Goals</h2>
        <div className={styles.futuregrid}>
          <div className={styles.futureimage}>
            <img src={vr} alt="vr" />
          </div>
          <div className={styles.rightside}>
            <h2 className={styles.subheading2}>Metaverse</h2>
            <span>Metaverse the future of virtual world</span>
            <p>
              A metaverse is a network of 3D virtual worlds focused on social
              connection.In futurism and science fiction, it is often described
              as a hypothetical iteration of the Internet as a single, universal
              virtual world that is facilitated by the use of virtual and
              augmented reality headsets
            </p>
          </div>
          <div className={styles.futureimage}>
            <img src={industrial} alt="" />
          </div>
          <div className={styles.rightside}>
            <h2 className={styles.subheading2}>Industrial Training</h2>
            <span>
              An effort to train people for a better future and minimize gaps in
              skills
            </span>
            <p>
              On-the-job training (widely known as OJT) is an important topic of
              human resource management. It helps develop the career of the
              individual and the prosperous growth of the organization. On the
              job training is a form of training provided at the workplace.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
